import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import SalesProgramLayout from '../SalesProgramLayout';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import { FormattedHTMLMessage } from 'react-intl';
import InputNumberUnit from '../InputNumberUnit';
import OutputNumberUnit from '../OutputNumberUnit';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import BottleSelector from '../BottleSelector';
import StarsSpinner from '../StarsSpinner';
class SalesProgram extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;

		const { game } = this.props;

		const { viewMode } = game;

		const {
			price,
			daysReceivable,
			marketingExpenses,
			quality,
			soldUnits,
			demandQuota,
			supplierBottleChoice
		} = game.sales;

		const variables = [
			{ id: 'selling-price', unit: '€/U', value: price, step: 0.1 },
			{ id: 'days-in-receivables', unit: 'DAYS', value: daysReceivable },
			{ id: 'marketing-expenses', unit: '€', value: marketingExpenses, step: 100000 }
		];
		const variablesTotals = [
			{ id: 'perpective-unit-sales', unit: 'U', value: soldUnits },
			{ id: 'market-share', unit: '%', value: demandQuota, multiplier : 100, decimals : true }
		];

		return (
			<div className="sales-program">
				<SalesProgramLayout>
					<BusinessPlanSubSectionTitle label={'sales-program-title'} />
					<ThreeYearsTableLayout>
						<Header />
						{variables.map(variable => (
							<Row key={variable.id}>
								<Label>
									<FormattedHTMLMessage id={variable.id} />
								</Label>
								{range(1, 4).map(n => (
									<Col key={n}>
										<InputNumberUnit
											active={!viewMode}
											unit={variable.unit}
											variable={variable.value[n - 1]}
											step={variable.step}
										/>
									</Col>
								))}
							</Row>
						))}
					</ThreeYearsTableLayout>
					<div className="sales-program-bottle-selector-label">
						<FormattedHTMLMessage id={'select-bottle-model'} />
					</div>
					<BottleSelector variable={supplierBottleChoice} active={!viewMode} />
					<ThreeYearsTableLayout>
						<Row>
							<Label>
								<FormattedHTMLMessage id={'quality'} />
							</Label>
							{range(1, 4).map(n => (
								<Col key={n}>
									<StarsSpinner
										variable={quality[n - 1]}
										disabled={true}
										output={true}
									/>
								</Col>
							))}
						</Row>
						{variablesTotals.map(variable => (
							<Row key={variable.id} black>
								<Label>
									<FormattedHTMLMessage id={variable.id} />
								</Label>
								{range(1, 4).map(n => (
									<Col key={n}>
										<OutputNumberUnit
											unit={variable.unit}
											variable={variable.value[n - 1]}
											multiplier={variable.multiplier}
											decimals={variable.decimals}
										/>
									</Col>
								))}
							</Row>
						))}
					</ThreeYearsTableLayout>
				</SalesProgramLayout>
			</div>
		);
	}
}

SalesProgram.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		sales: PropTypes.shape({
			price: MultiYearScalarType,
			daysReceivable: MultiYearScalarType,
			marketingExpenses: MultiYearScalarType,
			supplierBottleChoice: PropTypes.object,
			quality: MultiYearScalarType,
			soldUnits: MultiYearScalarType,
			demandQuota: MultiYearScalarType
		})
	})
};

export default SalesProgram;
